import PropTypes from 'prop-types';
import React from 'react';

import { imagePropTypes } from '../../../propTypes';

import Picture from '../Picture';

const propTypes = {
  className: PropTypes.string,
  image: imagePropTypes.isRequired,
};

const defaultProps = {
  className: '',
};

function Image(props) {
  return (
    <div className="Component Media">
      <div className="Media_content">
        {props.image && (
          <Picture
            {...props.image}
            sizes={[
              [100, 1.77], // from 0
              [100, 1.77], // from 440
              [100, 1.77], // from 768
              [100, 1.77], // from 1024
              ['1550', 1.77], // from 1440
            ]}
            className={props.className}
          />
        )}
      </div>
    </div>
  );
}

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

export default Image;
